import React, { createContext, useContext } from 'react';
import { Environment } from './environment';

const EnvironmentContext = createContext<Environment>(undefined as any);

export const EnvironmentProvider = ({ ...props }: React.PropsWithChildren<{ environment: Environment }>) => {
  return <EnvironmentContext.Provider value={props.environment} {...props} />;
};

export const useEnvironment = () => useContext(EnvironmentContext);
